import { useEffect, useRef } from 'react';

export const useInitializeDateRange = ({
    useRange,
    initialStartDate,
    initialEndDate,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    setInputStartDate,
    setInputEndDate,
    formatDate,
}: {
    useRange: boolean;
    initialStartDate: Date | null;
    initialEndDate: Date | null;
    startDate: Date | null;
    endDate: Date | null;
    setStartDate: (date: Date | null) => void;
    setEndDate: (date: Date | null) => void;
    setInputStartDate: (dateString: string) => void;
    setInputEndDate: (dateString: string) => void;
    formatDate: (date: Date | null) => string;
}) => {
    const wasManuallyCleared = useRef(false);

    useEffect(() => {
        if (startDate === null && endDate === null) {
            wasManuallyCleared.current = true;
        }
    }, [startDate, endDate]);

    useEffect(() => {
        if (!startDate && initialStartDate && !wasManuallyCleared.current) {
            setStartDate(initialStartDate);
            setInputStartDate(formatDate(initialStartDate));
        }
    }, [initialStartDate, startDate]);

    useEffect(() => {
        if (useRange) {
            if (!endDate && initialEndDate && !wasManuallyCleared.current) {
                setEndDate(initialEndDate);
                setInputEndDate(formatDate(initialEndDate));
            }
        } else {
            if (endDate !== null) {
                setEndDate(null);
                setInputEndDate('');
            }
        }
    }, [useRange, initialEndDate, endDate]);

    useEffect(() => {
        wasManuallyCleared.current = false;
    }, [useRange]);
};
